module.exports = __webpack_public_path__ + "static/07-e7a32c84505f416cf33a390a67a12712.jpg";